export const USER_MODULE_NAMESPACE = 'user';
export const USER_INFO = 'USER_INFO';
export const USER_INFO_STATUS = 'USER_INFO_STATUS';
export const USER_INFO_RECIEVED = 'USER_INFO_RECIEVED';
export const USER_INFO_MODULES_RECIEVED = 'USER_INFO_MODULES_RECIEVED';
export const USER_INFO_UPDATE = 'USER_INFO_UPDATE';
export const USER_INFO_PATCH = 'USER_INFO_PATCH';
export const REVERT_USER_INFO = 'REVERT_USER_INFO';
export const USER_INFO_FIELD = 'USER_INFO_FIELD';
export const USER_SIGN_UP = 'USER_SIGN_UP';
export const USER_SIGN_UP_VERIFY_BLOCK = 'USER_SIGN_UP_VERIFY_BLOCK';
export const USER_SIGN_UP_VERIFY = 'USER_SIGN_UP_VERIFY';
export const USER_INIT = 'USER_INIT'
export const USER_INFO_EDIT = 'USER_INFO_EDIT'
export const USER_ACTION = 'USER_ACTION'
export const USER_ACTION_TYPE = 'USER_ACTION_TYPE'
export const USER_SET_USER_BY_FIELD = 'USER_SET_USER_BY_FIELD'
export const USER_RESET_USER = 'USER_RESET_USER'



// WEBPACK FOOTER //
// ./src/store/user/user-types.store.ts